'use strict';

var isNode = typeof document === 'undefined';

var _ = require('lodash');
var Classnames = require('classnames');
var React = require('react');
var ReactDOM = require('react-dom');
var LinkedStateMixin = require('react-addons-linked-state-mixin');

var ReactRouter = require('react-router');
var Link         = ReactRouter.Link;

if (!isNode) {
    var DetectFlex = require('../../../../common-js/helpers').DetectFlex;
    var DetectFlex = require('../../../../common-js/helpers').DetectFlex;
    if (!DetectFlex()) {
        var Flexibility = require('flexibility');
    }
}

var Constants = require('../constants');
var Global = require('../global');
var ResponsiveMixin    = Global.ResponsiveMixin;

if (!isNode) {
    require('./breadcrumbs.scss');
}

const images = {
    plus: {src: `${Payload.static}/images/global/expansion/plus-solid-grey.svg`,width:'12',height:'12', alt:'Plus sign'},
    minus:{src: `${Payload.static}/images/global/type-arrows/down-grey5.png`,width:'12',height:'12', alt:'Down arrow white'},
    down: {src: `${Payload.static}/images/global/type-arrows/down-grey3.png`,width:'12',height:'5', alt:'Down arrow dark'}
}

var Breadcrumbs = React.createClass({
    mixins: [ ResponsiveMixin, LinkedStateMixin ],

    propTypes: {
        categories: React.PropTypes.array.isRequired,
    },

    getInitialState: function() {
        return {
            showQuicklinks: false,  // set to true to test QuicklinksReveal
            
            // True for any Quick Ship page
            quickship: (this.props.params && this.props.params.splat == 'quick-ship') 
                    || (this.props.route && _.startsWith(this.props.route.path, '/quick-ship')),
        };
    },
    _mouseOver: function() {
        this.setState({
            showQuicklinks: true,
        });
    },
    _mouseOut: function() {
        this.setState({
            showQuicklinks: false,
        });
    },
    render: function() {
        // For each crumb, the number in brackets denotes the background colour, and the name of the matching breadcrumb asset
        //     The Collection(3)
        //     The Collection(3) -> Category(1)
        //     The Collection(3) -> Category(2) -> Item(1)
        //     The Collection(3) -> Category(2) -> Sub-category(1)
        //     The Collection(3) -> Category(2b) -> Sub-category(2) -> Item(1)

        let trail,
            reveal;

        if (this.state.quickship) {
            trail = [{
                name: 'Quick Ship',
                url: '/quick-ship-fast-office-furniture',
                bg: '3',
            }];

            // Quick Ship listing is already given standard catalog breadcrumb - ignore it
            if (this.props.trail.length > 1) {
                trail = trail.concat(this.props.trail[this.props.trail.length-1]);
            }
        } else {
            trail = [{
                name: 'Product Collection', // TODO make text
                url: '/office-furniture-los-angeles',
                bg: '3',
            }].concat(this.props.trail);

            if (trail.length > 1) {
                if (trail.length == 2) {
                    trail[1].bg = '4';
                }
                if (trail.length == 3) {
                    trail[1].bg = '4';
                    trail[2].bg = '2';
                }
                if (trail.length == 4) {
                    trail[1].bg = '4';
                    trail[2].bg = '5';
                    trail[3].bg = '6';
                }
            }

            reveal = (
                <QuicklinksReveal categories     = {this.props.categories}
                                  showQuicklinks = {this.linkState('showQuicklinks')} />
            );

        }

        var desktop = this.state.viewportLayout == 'desktop';

        var crumbs = trail.map((B, ix) => {
            var name = B.listing_name || B.name
            var label = desktop ? name : name.toUpperCase()
            return (
                <div key         = {B.url}
                     className   = {`co-bread-crumb co-bread-${B.bg}`}
                     onMouseOver = {this.state.viewportLayout == 'desktop' && ix == 0 && !this.state.quickship ? this._mouseOver : null}>
                    <div className='co-bread-label'>
                        
                        {ix == 0 && desktop ?
                            reveal
                        : null}

                        {ix == trail.length-1 ?
                            label
                        :
                            <Link to={B.url}>
                                {label}
                            </Link>
                        }

                        {desktop && ix < trail.length - 1 ?
                            <span className='co-bread-label-sep'>
                                /
                            </span>
                        : null}
                    </div>

                    {ix == 0 && !desktop ?
                        reveal
                    : null}
                </div>
            );
        });
        return (
            <div>
                <div onMouseLeave={this._mouseOut}>
                    <BreadcrumbsSchema trail={trail} />
                    <div className='co-breadcrumbs'>
                        {crumbs}

                        {!this.state.quickship ?
                            <QuickLinksMenu categories     = {this.props.categories}
                                            showQuicklinks = {this.linkState('showQuicklinks')} />
                        : null}
                    </div>
                </div>
                {this.state.showQuicklinks ?
                    <div className='co-breadcrumbs-shade' />
                : null}
            </div>
        );
    }
});

var BreadcrumbsSchema = (props) => {
    var jsonLD = {
        "@context" : "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": props.trail.map((crumb, ix) => {
            return {
                "@type": "ListItem",
                "position": ix,
                "item": {
                    "@id": crumb.url,
                    "name": (crumb.listing_name || crumb.name).toUpperCase(),
                }
            }
        })
    };
    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }} />
    );
};

var QuickLink = React.createClass({
    mixins: [ ResponsiveMixin ],

    click: function() {
        this.props.showQuicklinks.requestChange(false);
    },
    render: function() {
        return (
            <Link to          = {this.props.category.url}
                  onClick     = {this.click}
                  className   = 'co-quicklinks-qlink'>
                {this.state.viewportLayout == 'desktop' ?
                    <div className='co-quicklinks-qlink-label'>
                        {this.props.category.listing_name || this.props.category.name }
                    </div>
                :
                    <div>
                        <div className='co-quicklinks-qlink-icon'>
                            <img src={Constants.static + 'images/categories/icons/dark/' + this.props.category.urlkey + '.png'} />
                        </div>
                        <div className='co-quicklinks-qlink-label'>
                            {this.props.category.short_name}
                        </div>
                    </div>
                }
            </Link>
        );
    },
});

var QuickLinksMenu = React.createClass({
    mixins: [ LinkedStateMixin ],

    propTypes: {
        categories: React.PropTypes.array.isRequired,
        showQuicklinks: React.PropTypes.object.isRequired,
    },

    componentDidMount: function() {
        this.componentDidUpdate();
    },
    componentDidUpdate: function() {
        if (this.props.showQuicklinks.value) {
            if (Flexibility) {
                Flexibility(this.refs.quicklinks);
            }
        }
    },
    render: function() {
        if (!this.props.showQuicklinks.value)
            return null;
        
        var collections = this.props.categories.filter((c) => {
                return c.seq != null;
            }).map(cat => {
            return (
                <QuickLink key            = {cat.id}
                           category       = {cat}
                           showQuicklinks = {this.props.showQuicklinks} />
            );
        });
        return (
            <div className='co-quicklinks-menu' data-style='display: flex;' ref='quicklinks'>
                {collections}
            </div>
        );
    }
});

var QuicklinksReveal = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        categories: React.PropTypes.array.isRequired,
        showQuicklinks: React.PropTypes.object.isRequired,
    },

    click: function() {
        this.props.showQuicklinks.requestChange(!this.props.showQuicklinks.value);
    },
    render: function() {
        var icon = this.props.showQuicklinks.value ? 'minus' : 'plus';
        return (
            <div className ='co-quicklinks-reveal'
                 onClick   = {this.state.viewportLayout != 'desktop' ? this.click : null}>

                <img className = 'co-quicklinks-dropdown'
                     src       = {images[icon].src}
                     width     = {images[icon].width}
                     height    = {images[icon].height} 
                     alt       = {images[icon].alt}             
                />

                {this.state.viewportLayout == 'desktop' || this.props.showQuicklinks.value ?
                    <img className = 'co-quicklinks-flag'
                         src       = {images['down'].src} 
                         width     = {images[icon].width}
                         height    = {images[icon].height}
                         alt       = {images[icon].alt}  
                />
                : null}
            </div>
        );
    },
});

module.exports = Breadcrumbs;



// WEBPACK FOOTER //
// ./src/collections/breadcrumbs.jsx